export default __webpack_public_path__ + "static/media/Dr-Julien-Weissenberg.c325893a.jpg";